export default __webpack_public_path__ + "static/media/crm_icon_white.403d0af2.svg";